module.exports = __webpack_public_path__ + "media/img/vca/nome2-312a4ff08cda787bf7448fc15e276f00.png";